<template>
    <div>
        <accordion
            sub
            visible
            title="Grafico"
            :id="`${dados.id}-1`"
            :accordion="`${dados.id}-1`"
        >
            <div class="pr-3">
                <grafico :dados="dados" />
            </div>
        </accordion>
        <accordion
            sub
            title="Projetos"
            :id="`${dados.id}-2`"
            :accordion="`${dados.id}-2`"
        >
            <div class="p-3 pb-0">
                <b-table head-variant="dark" small :items="dados.projetos" :fields="colunas"></b-table>
            </div>
        </accordion>
    </div>
</template>
<script>
import Grafico from "./Grafico.vue"
import Accordion from '@/components/card/Accordion';
import helpers from "@/common/utils/helpers";
export default {
    components : {
        Accordion,
        Grafico
    },
    props : {
        dados : {
            required : true
        }
    },
    data : () => ({
        colunas : [
            {key : "dataInicio", label : "Data de inicio", formatter : (v) => { if(v) return helpers.formatarDataBr(v)}},
            {key : "periodicidade", label : "Periodicidade"},
            {key : "valor", label : "Valor", formatter : (v) => { if(v) return helpers.formatarValor(v)}},
            {key : "acoes", label : "Ações"},
        ],
    })
    
}
</script>
<style lang="">
    
</style>